import { render, staticRenderFns } from "./home_person.vue?vue&type=template&id=7b3eb55d&scoped=true"
import script from "./home_person.vue?vue&type=script&lang=js"
export * from "./home_person.vue?vue&type=script&lang=js"
import style0 from "./home_person.vue?vue&type=style&index=0&id=7b3eb55d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e128dc07b65f661f3a32bbc83dd42e36/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3eb55d",
  null
  
)

export default component.exports